import React from 'react';
import { imageZone, imageZoneWithImgData } from '../ZonesList/ZonesList.types';
import ZonePreview from '../ZonePreview/ZonePreview.component';
import { useStyles } from './ClusterList.styles';

interface ClusterListProps {
  zones: imageZoneWithImgData[];
  currentZoneIndex?: number;
  onClickZone: (zone: imageZone) => void;
}

const ClusterList: React.FC<ClusterListProps> = (props) => {
  const classes = useStyles();

  return (
    <>
      {props.zones.map((item: imageZoneWithImgData) => {
        const isActive = props.currentZoneIndex === item.zone.orderNumber;
        return (
          <div key={item.zone.orderNumber}>
            <ZonePreview
              className={isActive ? [classes.zoneImg, classes.zoneImgActive].join(' ') : classes.zoneImg}
              wholeImageData={item.wholeImageData}
              zone={item.zone}
              canvasWidth={450}
              onClick={() => props.onClickZone(item.zone)}
              title={`Klaster - obszar ${item.zone.orderNumber + 1}`}
            />
          </div>
        );
      })}
    </>
  );
};

export default React.memo(ClusterList);
